import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Play } from '@/shared/ui/Icons'

import { SwitchComponent } from '@/components/settings/components/SwitchComponent'
import { useState } from 'react'
import { useSharedStyles } from '@/pages/Settings/useSharedStyles'

const TermsOfService = () => {
    const [checked, setChecked] = useState(false)
    const { t: translate } = useTranslation()
    const {
        titleStyle,
        titleContainer,
        sectionStyle,
        container,
        iconContainer,
        dataContainer,
    } = useSharedStyles()
    return (
        <Box sx={container}>
            <Typography mt="24px" sx={titleStyle}>
                {translate('settings')}
            </Typography>

            <Box sx={sectionStyle}>
                <Box sx={titleContainer}>
                    <Box sx={iconContainer}>
                        <Play />
                    </Box>
                    <Typography ml="24px" sx={titleStyle}>
                        {translate('info')}
                    </Typography>
                </Box>
                <Box sx={dataContainer}>
                    <SwitchComponent
                        fieldName="ConsentMarketing"
                        value={checked}
                        onChange={() => setChecked((prev) => !prev)}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export { TermsOfService }
